<div class="c-card g--margin-t-15">
    <div class="c-card__body g--margin-b-30">

        <!-- Grupo Preferencias Tren -->
        <ng-container *ngFor="let preferencia of preferencias">
            <div class="g--margin-t-30" 
              *ngIf="preferencia.TipoProducto === ETipoProducto.Tren  && preferencia.Visible && preferencia.Opciones !== null"> 
                <app-grupo-preferencia
                    #Grupo_Preferencia_Tren
                    [Id]="preferencia.Id"
                    [TituloGrupo]="preferencia.ClaveTraduccion"
                    [ListaPreferencias] = "preferencia.Opciones"
                    [multiple]="preferencia.SeleccionMultiple"
                    [required]="preferencia.Obligatorio"
                    [listaOtros]="listaOtros"> 
                </app-grupo-preferencia>
            </div>
        </ng-container>

         <!-- Observaciones Tren -->
         <div class="g--margin-t-30">
            <div class="g--margin-t-30 c-section-altnative c-table c-table--scroll">
                <div class="c-section-alternative__header">
                    <app-observaciones
                    #Grupo_Preferencia_Tren_Observaciones
                    [(textareaValue)] = "texto"
                    (textareaValueChange)="actualizarValorObservacion($event)"
                    ></app-observaciones>
                </div>
            </div>
        </div>
    </div>
</div>
